import React from 'react';
import Header from '../components/Header';
import AnnouncementBar from '../components/AnnouncementBar';
import Hero from '../components/Hero';
import Trustpilot from '../components/Trustpilot';
import Categories from '../components/Categories';
import Marquee from '../components/Marquee';
import Stats from '../components/Stats';
import GoogleReviewsSection from '../components/GoogleReviewsSection';
import Testimonials from '../components/Testimonials';
import FAQ from '../components/FAQ';
import Footer from '../components/Footer';

const Home = () => {
  return (
    <div>
      <AnnouncementBar />
      <Header />
      <main>
        <Hero />
        <Marquee />
        <Categories />
        <GoogleReviewsSection />
        <Stats />
        <Trustpilot />
        <Testimonials />
        <FAQ />
      </main>
      <Footer />
    </div>
  );
};

export default Home;
